import { useCallback } from 'react';
import type {
  FieldValues,
  UseFormSetError,
  UseFormClearErrors,
  UseFormSetValue,
} from 'react-hook-form';

type UseProRateEffectProps = {
  isW2Local: boolean;
  setError: UseFormSetError<FieldValues>;
  clearErrors: UseFormClearErrors<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  source: string;
};

export const useProRateEffect = ({
  isW2Local,
  setError,
  clearErrors,
  setValue,
  source,
}: UseProRateEffectProps) => {
  const validateBaseMarginPercentW2 = useCallback(
    (value: number) => {
      if (!isW2Local) {
        return;
      }

      const fieldName = `${source}.base_margin_percent_w2`;

      if (value < 0) {
        setError(
          fieldName,
          {
            type: 'manual',
            message: 'Base margin percent W2 cannot be less than 0',
          },
          {
            shouldFocus: true,
          },
        );
        setValue(fieldName, value.toFixed(5), { shouldTouch: true });
      } else {
        clearErrors(fieldName);
      }
    },
    [isW2Local, source, setError, clearErrors, setValue],
  );

  return {
    validateBaseMarginPercentW2,
  };
};
